import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from '../finance/shared';

const BusinessDaysCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [startDate, setStartDate] = useState('2024-01-01');
  const [endDate, setEndDate] = useState('2024-12-31');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    if (!startDate || !endDate) return;
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) return;

    const holidays = [
      { month: 0, day: 1 }, { month: 3, day: 21 }, { month: 4, day: 1 },
      { month: 8, day: 7 }, { month: 9, day: 12 }, { month: 10, day: 2 },
      { month: 10, day: 15 }, { month: 11, day: 25 }
    ];

    let totalDays = 0, businessDays = 0, weekends = 0, holidaysCount = 0;
    const current = new Date(start);
    while (current <= end) {
      totalDays++;
      const dayOfWeek = current.getDay();
      if (dayOfWeek === 0 || dayOfWeek === 6) weekends++;
      else {
        businessDays++;
        if (holidays.some(h => h.month === current.getMonth() && h.day === current.getDate())) {
          businessDays--;
          holidaysCount++;
        }
      }
      current.setDate(current.getDate() + 1);
    }

    setResultState({ totalDays, businessDays, weekends, holidays: holidaysCount });
    onResultChange([
      { label: 'Dias Totais', value: totalDays.toString() },
      { label: 'Dias Úteis', value: businessDays.toString() },
      { label: 'Feriados', value: holidaysCount.toString() }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="Data Inicial" value={startDate} onChange={setStartDate} type="date" required />
          <FormField label="Data Final" value={endDate} onChange={setEndDate} type="date" required />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all">Calcular</button>
        </div>
        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ResultCard title="Dias Úteis" value={resultState.businessDays} color="emerald" description={`De um total de ${resultState.totalDays} dias`} />
            <ResultCard title="Feriados/FDS" value={resultState.holidays + resultState.weekends} color="amber" description={`${resultState.holidays} feriados e ${resultState.weekends} fds`} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BusinessDaysCalculator;
